import React, { useState, useEffect } from "react";
import PhoneCpt from "./PhoneCpt";
import "antd/dist/antd.css";
import { Tag, Space } from "antd";
import axios from "axios";

const compte = localStorage.getItem("compte");
const posteCol = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");

function Webphone() {
  const [isOpen, setIsOpen] = useState(true);
  const [navbar, setNavbar] = useState(true);
  const [upWebphone, setUpWebphone] = useState(0);
  const BackendURL = window.BackendURLCmk;
  // var icon =
  //   document.getElementsByClassName("pageDown")[0] === undefined ? (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       className="h-5 w-5"
  //       viewBox="0 0 20 20"
  //       fill="currentColor"
  //       style={{
  //         margin: "13px 0px 8px 12px",
  //         color: "white",
  //         cursor: "pointer",
  //       }}
  //     >
  //       <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
  //     </svg>
  //   ) : (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       className="h-5 w-5"
  //       fill="none"
  //       viewBox="0 0 24 24"
  //       stroke="currentColor"
  //       strokeWidth={2}
  //       style={{
  //         transform: "rotate( 136deg )",
  //         borderRadius: "100%",
  //         margin: "13px 0px 8px 12px",
  //         color: "white",
  //         cursor: "pointer",
  //         border: "1px solid #e7edeb57",
  //       }}
  //     >
  //       <path
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         d="M8 9l4-4 4 4m0 6l-4 4-4-4"
  //       />
  //     </svg>
  //   );

  function maekeUp(count) {
    setUpWebphone(count);
  }
  useEffect(() => {
    var config1 = {
      headers: {
        Authorization: token,
      },
    };
    const result1 = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/IpPublicIPBXV3API?compte=${compte}&poste=${posteCol}`,
        config1
        // config
      )
      .then(function (response) {
        var config = {
          headers: {
            Authorization: token,
          },
        };
        const result = axios
          .get(
            `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/IPCOMUNIKSOFTPHONEDECLARWS?compte=${compte}&adresse_ip=${response.data.ip_public}&poste=${posteCol}`,
            config
            // config
          )
          .then(function (response) {})
          .catch(function (error) {});
      })
      .catch(function (error) {});
  }, []);

  const handleModel = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  const handleNavbar = () => {
    if (navbar) {
      setNavbar(false);
    } else {
      setNavbar(true);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Tags",
      key: "tags",
      dataIndex: "tags",
      render: (tags) => (
        <>
          {tags.map((tag) => {
            let color = tag.length > 5 ? "geekblue" : "green";
            if (tag === "loser") {
              color = "volcano";
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <a>Invite {record.name}</a>
          <a>Delete</a>
        </Space>
      ),
    },
  ];

  const data = [
    {
      key: "1",
      name: "John Brown",
      age: 32,
      address: "New York No. 1 Lake Park",
      tags: ["nice", "developer"],
    },
    {
      key: "2",
      name: "Jim Green",
      age: 42,
      address: "London No. 1 Lake Park",
      tags: ["loser"],
    },
    {
      key: "3",
      name: "Joe Black",
      age: 32,
      address: "Sidney No. 1 Lake Park",
      tags: ["cool", "teacher"],
    },
  ];

  return (
    <div
      className="webphone"
      style={{
        zIndex: "1",
        width: navbar ? "90%" : "50%",
        height: navbar ? "100%" : "50%",
        margin: "auto",
        position: navbar ? "relative" : "absolute",
      }}
    >
      <div
        style={{
          position: "relative",
          height: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            // width: navbar ? (isOpen ? "550px" : "") : isOpen ? "915px" : "",
            backgroundColor:
              window.switchAPI === "govoice" ? "#182436" : "rgb(8 116 85)",
            borderRadius: "20px",
            borderRadius: "31px",
            filter: "drop-shadow(2px 4px 6px #050a11)",
            height: "100%",
          }}
        >
          {!isOpen ? (
            <span
              style={{ borderRadius: "30px 0px 0px 30px", zIndex: "2" }}
              onClick={() => setIsOpen(true)}
            >
              {upWebphone === 0 ? (
                <div className="tooltip" style={{ display: "block" }}>
                  <span class="tooltiptext">Agrandir</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    style={{
                      margin: "13px 0px 8px 12px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                </div>
              ) : (
                <div className="tooltip " style={{ display: "block" }}>
                  <span class="tooltiptext">Agrandir</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                    style={{
                      transform: "rotate( 136deg )",
                      borderRadius: "100%",
                      margin: "13px 0px 8px 12px",
                      color: "white",
                      cursor: "pointer",
                      border: "1px solid #e7edeb57",
                    }}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                    />
                  </svg>
                </div>
              )}
            </span>
          ) : null}
          <PhoneCpt navbar={navbar} isOpen={isOpen} maekeUp={maekeUp} />

          {isOpen ? (
            <div>
              <div></div>

              <div
                className="resizeButton"
                style={{
                  position: "absolute",
                  backgroundColor: "rgb(244 244 244)",
                  width: "10px",
                  top: "71px",
                  height: "74px",
                  borderRadius: "0px 16px 16px 0px",
                  cursor: "pointer",
                  display: "flex",
                  color: "white",
                }}
                onClick={() => handleNavbar()}
              >
                {navbar ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-gray-800"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13 5l7 7-7 7M5 5l7 7-7 7"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-gray-800"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    {" "}
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
                    />{" "}
                  </svg>
                )}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Webphone;
